<template>
  <div>
    <div class="header-top">
      <div class="header page-continer">
        <div class="left-cont">
          <div class="logo" @click="logoHanlder">
            <img
              src="//kandian-1254383113.file.myqcloud.com/cloud/pc/head-logo.png"
            />
          </div>
          <div class="menus">
            <router-link
              to="/"
              class="menu"
              :class="{ active: $route.fullPath === '/index' }"
            >
              首页
            </router-link>
            <div class="menu">
              <div class="menu">下载APP</div>
              <img
                class="down-app"
                src="../../assets/images/download-app.jpg"
              />
            </div>
            <div
              @click="myCourseHandler"
              class="menu"
              :class="{ active: $route.fullPath === '/person/course' }"
            >
              我的课程
            </div>
          </div>
        </div>
        <div v-if="headerUserinfoShow" class="user-info" @click="linkPerson">
          <div class="head-box">
            <div class="logout">
              <div
                class="el-dropdown-link"
                @mouseenter="logoutEnterHandler"
                @mouseleave="logoutLeaveHandler"
              >
                <img
                  v-if="userInfo.avatar"
                  class="head"
                  :src="userInfo.avatar"
                />
                <img
                  v-else
                  class="head"
                  src="//kandian-1254383113.file.myqcloud.com/cloud/pcdefault-avatar.png"
                />
                <div class="logout-box" v-if="logoutShow">
                  <div class="txt" @click="logoutHandler">退出</div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="userInfo.name" class="user-name">{{ userInfo.name }}</div>
          <div v-else class="user-name">{{ userInfo.tel }}</div>
        </div>
        <el-button v-else class="login" @click="loginHandler">
          立即登录
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getCookie, clearCookie } from '../../utils/utils'
export default {
  name: 'headNav',

  computed: {
    ...mapGetters(['userInfo', 'userId', 'headerUserinfoShow']),
  },
  data() {
    return {
      loginOk: false,
      logoutShow: false,
    }
  },
  async mounted() {
    let userId = getCookie('uid')
    if (!this.userInfo.userId && !userId) return
    const { code = 1, msg = '', ...res } = await this.$store.dispatch(
      'user/getInfo',
    )
    if (code === 0) {
      this.loginOk = true
      const info = res.data.userInfo
      if (info.avatar) {
        this.imageUrl = info.avatar
      }
    } else {
      this.$message({
        center: true,
        message: msg,
        type: 'error',
      })
    }
  },
  methods: {
    logoHanlder() {
      this.$router.push('/')
    },
    loginHandler() {
      this.$store.dispatch('user/openLogin', true)
    },
    myCourseHandler() {
      if (this.userId) {
        this.loginOk = true
        this.$router.push('/person/course')
      } else {
        this.loginOk = false
        this.$store.dispatch('user/openLogin', true)
      }
    },
    linkPerson() {
      this.$router.push('/person/base')
    },
    async logoutHandler(data) {
      clearCookie('userinfo')
      await this.$store.dispatch('user/logout')
      this.$router.push('/index')
    },
    logoutEnterHandler() {
      this.logoutShow = true
    },
    logoutLeaveHandler() {
      this.logoutShow = false
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" src="./scss/header.scss"></style>



// WEBPACK FOOTER //
// src/components/layout/head.vue